import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Calendar } from 'lucide-react';
import { formatScheduledDate } from './contentHelpers';

/**
 * Edit schedule dialog used by LessonsTab and ContentTab.
 * Props: item (or null), onClose, onSave({scheduled_for}), t
 */
export default function EditScheduleDialog({ item, onClose, onSave, t }) {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  useEffect(() => {
    if (item?.scheduled_for) {
      const dt = new Date(item.scheduled_for);
      setDate(dt.toISOString().split('T')[0]);
      setTime(dt.toTimeString().slice(0, 5));
    } else {
      setDate('');
      setTime('');
    }
  }, [item]);

  const handleSave = () => {
    const scheduled_for = (date && time) ? new Date(`${date}T${time}`).toISOString() : '';
    onSave(scheduled_for);
  };

  return (
    <Dialog open={!!item} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Montserrat' }} className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-blue-500" /> {t('edit_schedule')}
          </DialogTitle>
        </DialogHeader>
        {item && (
          <div className="space-y-4 pt-2">
            <div className="bg-slate-50 rounded-lg p-3">
              <p className="text-sm font-medium text-slate-700">{item.title}</p>
              {item.scheduled_for && !item.is_published && (
                <p className="text-xs text-amber-600 mt-1">
                  {t('scheduled_for')}: {formatScheduledDate(item.scheduled_for)}
                </p>
              )}
            </div>
            <div className="flex gap-3">
              <div className="flex-1">
                <Label className="text-xs text-slate-500 mb-1 block">Fecha</Label>
                <Input
                  type="date" value={date} onChange={e => setDate(e.target.value)} className="bg-white"
                  data-testid="edit-schedule-date" min={new Date().toISOString().split('T')[0]}
                />
              </div>
              <div className="flex-1">
                <Label className="text-xs text-slate-500 mb-1 block">Hora</Label>
                <Input
                  type="time" value={time} onChange={e => setTime(e.target.value)} className="bg-white"
                  data-testid="edit-schedule-time"
                />
              </div>
            </div>
            <div className="flex gap-2">
              <Button onClick={handleSave} className="flex-1" data-testid="save-schedule-btn">
                {date && time ? t('schedule_publication') : t('publish_now')}
              </Button>
              <Button variant="outline" onClick={onClose} className="flex-1">{t('cancel')}</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
